import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { CCard, CCardBody, CCardHeader, CSmartTable } from '@coreui/react-pro';

import { formatDate } from '../../../../../utils';
import {
     DEFAULT_DATE_MONTH_NAME_TIME_FORMAT,
     DEFAULT_PAGINATION,
     DEFAULT_SORT_BY,
     SORTING_TYPE,
     SYSTEM_ADMIN_PATH,
     USER_SURVEY_ADMIN_COLUMNS,
} from '../../../../../constants';

import { fetchAdminUserSurveysRequest } from './action';

const UserSurveys = () => {
     const dispatch = useDispatch();
     const { id } = useParams();
     const isLoading = useSelector((state) => state.general.isLoading);

     const [userSurveys, setUserSurveys] = useState([]);

     const fetchUserSurveys = () => {
          if (!userSurveys.length) {
               dispatch(fetchAdminUserSurveysRequest(id, setUserSurveys));
          }
     };
     useEffect(fetchUserSurveys, []); // eslint-disable-line react-hooks/exhaustive-deps

     return (
          <>
               <div className="mb-2">
                    <Link to={SYSTEM_ADMIN_PATH.SURVEYS_DETAIL.replace(':id', id)} className="mb-2">
                         {`< Go Back`}
                    </Link>
               </div>
               <CCard className="mb-4">
                    <CCardHeader className="d-flex justify-content-between align-items-center">
                         <div className="card-header-text">
                              <strong>User Surveys</strong>
                              <p className="m-0">View, all User Surveys inside the CAMS Training Platform</p>
                         </div>
                    </CCardHeader>
                    <CCardBody>
                         <div className="table-responsive middle-table">
                              <CSmartTable
                                   clickableRows
                                   sorterValue={{
                                        column: DEFAULT_SORT_BY.CREATED_AT,
                                        state: SORTING_TYPE.DESC,
                                   }}
                                   tableFilter
                                   pagination
                                   itemsPerPageSelect
                                   itemsPerPage={DEFAULT_PAGINATION.PAGE_SIZE}
                                   items={userSurveys}
                                   columns={USER_SURVEY_ADMIN_COLUMNS}
                                   loading={isLoading}
                                   scopedColumns={{
                                        createdAt: (item) => (
                                             <td>{formatDate({ date: item.createdAt, format: DEFAULT_DATE_MONTH_NAME_TIME_FORMAT })}</td>
                                        ),
                                        viewDetails: (item) => {
                                             return (
                                                  <td className="py-2 table-column-button">
                                                       <Link
                                                            className="btn btn-outline-primary btn-sm btn-square w-100"
                                                            to={SYSTEM_ADMIN_PATH.SURVEY_USER_SURVEY_DETAILS.replace(':id', id).replace(
                                                                 ':userSurveyId',
                                                                 item.id
                                                            )}
                                                       >
                                                            View Details
                                                       </Link>
                                                  </td>
                                             );
                                        },
                                   }}
                              />
                         </div>
                    </CCardBody>
               </CCard>
          </>
     );
};

export default UserSurveys;
